export class OrderInformation {
    public OrderInfoId: number;
    public QuoteId: number;
    public RetailerPickup: boolean;
    public SalesNote: string;
    public OrderedBy: string;
    public AltConstruction: boolean;
    public ModOffFrame: boolean;
    public PerimiterBlocking: boolean;
    public FinanceSource: string;
    public FinanceSources: string[];
    public FreightCode: string;
    public FreightCodes: string[];
    public RetailerShipTo: string;
    public BaseAmount: number;
    public AdjustedSquareFootage: number;
    public SurchargeOverride: string;
    public FreightOverride: string;
    public SpecialInstructions: string;
    public RetailerRequests: string;
    public ModifiedBy: string;
    public ModelBaseOverride?: number;
	public QuoteRevisionNumber: number;

    constructor() {
        this.ModelBaseOverride = null;
        this.FinanceSources = new Array<string>('No Finance Flooring Source(s) Available');
        this.FreightCodes = new Array<string>('No Freight Code(s) Available');
        this.ModifiedBy = "System User";
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/order-information.ts